"use client";

import { ComboboxItem, JollyComboBox } from "@/components/rac/combobox";
import { type Country, getCountriesWithPhoneCodes } from "@/info/countries";

interface CountrySelectorProps {
	selectedCountry: Country;
	onCountryChange: (country: Country) => void;
	isDisabled?: boolean;
	hideLabel?: boolean;
}

export function CountrySelector({
	selectedCountry,
	onCountryChange,
	isDisabled = false,
	hideLabel = false,
}: CountrySelectorProps) {
	const countries = getCountriesWithPhoneCodes();

	return (
		<div className={hideLabel ? "mb-2" : "mb-4"}>
			<JollyComboBox
				label="Country"
				placeholder="Search countries..."
				menuTrigger="focus"
				selectedKey={selectedCountry.countryCode}
				onSelectionChange={key => {
					if (key) {
						const country = countries.find(c => c.countryCode === key);
						if (country) {
							onCountryChange(country);
						}
					}
				}}
				isDisabled={isDisabled}
				className="w-full"
			>
				{countries.map(country => (
					<ComboboxItem
						key={country.countryCode}
						id={country.countryCode}
						textValue={`${country.flag}  ${hideLabel ? "" : country.name} ${country.code}`}
						className="flex items-center gap-3 py-2 px-3 cursor-pointer data-[focused]:bg-gray-100 data-[selected]:bg-blue-50 rounded-md"
					>
						<span className="text-base">{country.flag}</span>
						<div className="flex justify-between w-full">
							{!hideLabel && <span className="text-sm font-medium">{country.name}</span>}
							<span className="text-xs text-gray-500">{country.code}</span>
						</div>
					</ComboboxItem>
				))}
			</JollyComboBox>
		</div>
	);
}
